import restApiDispatcher from "@/store/utils/api-dispatcher";
import { College } from "@/models";

const getColleges = (context, params) =>
  restApiDispatcher(context, {
    resource: College,
    storeKey: "colleges",
    loadingKey: "collegesLoading",
    action: "index",
    commitType: "index",
    metaKey: "meta",
    params
  });

const getCollege = (context, params) =>
  restApiDispatcher(context, {
    resource: College,
    storeKey: "college",
    loadingKey: "collegeLoading",
    action: "show",
    commitType: "wrappedShow2",
    params
  });

const getAllColleges = (context, params) =>
  restApiDispatcher(context, {
    resource: College,
    storeKey: "allColleges",
    loadingKey: "allCollegesIndex",
    action: "getAllColleges",
    commitType: "index",
    silent: "true",
    params
  });

const getVideos = (context, params) =>
  restApiDispatcher(context, {
    resource: College,
    storeKey: "videos",
    loadingKey: "videosLoading",
    action: "getVideos",
    params
  });

const getLimitedVideos = (context, params) =>
  restApiDispatcher(context, {
    resource: College,
    storeKey: "limitedVideos",
    loadingKey: "videosLoading",
    action: "getLimitedVideos",
    params
  });

const updateCollege = (context, params) =>
  restApiDispatcher(context, {
    resource: College,
    storeKey: "college",
    loadingKey: "college",
    action: "update",
    commitType: "wrappedShow2",
    message: "College info updated",
    params
  });

const updateCollegeLogo = (context, params) =>
  restApiDispatcher(context, {
    resource: College,
    action: "updateCollegeLogo",
    storeKey: "college",
    loadingKey: "collegeLoading",
    commitType: "wrappedShow2",
    params
  });

const deleteCollegeVideos = (context, params) =>
  restApiDispatcher(context, {
    resource: College,
    action: "deleteCollegeVideos",
    storeKey: "video",
    loadingKey: "videosLoading",
    commitType: "wrappedShow2",
    message: "Video deleted.",
    params
  });

const saveCollegeVideos = (context, params) =>
  restApiDispatcher(context, {
    resource: College,
    action: "saveCollegeVideos",
    storeKey: "video",
    loadingKey: "videosLoading",
    commitType: "wrappedShow2",
    message: "New video added.",
    params
  });

const updateCollegeVideos = (context, params) =>
  restApiDispatcher(context, {
    resource: College,
    action: "updateCollegeVideos",
    storeKey: "video",
    loadingKey: "videosLoading",
    commitType: "wrappedShow2",
    message: "Video updated.",
    params
  });

const uploadCollegeImages = (context, params) =>
  restApiDispatcher(context, {
    resource: College,
    action: "uploadCollegeImages",
    storeKey: "collegeImageUpload",
    loadingKey: "collegeImageUploadLoading",
    message: "Upload Complete",
    params
  });

const deleteCollegeImages = (context, params) =>
  restApiDispatcher(context, {
    resource: College,
    action: "deleteCollegeImages",
    storeKey: "deleteImage",
    loadingKey: "deleteImageLoading",
    message: "Image Deleted",
    params
  });


const updateViewCount = (context, params) => 
  restApiDispatcher(context, {
    resource: College, 
    action: 'updateViewCount',
    storeKey: 'count',
    commitType: 'show',
    loadingKey: 'collegeLoading',
    params
  })

const removeDeletedVideoMutation = (context, params) =>
  context.commit("REMOVE_VIDEOS_MUTATION", params);

const setFavourite = (context, collegeId) =>
  context.commit("SET_FAVOURITE", collegeId);

const unsetFavourite = (context, collegeId) =>
  context.commit("UNSET_FAVOURITE", collegeId);

export default {
  getColleges,
  setFavourite,
  unsetFavourite,
  getCollege,
  getVideos,
  updateCollege,
  updateCollegeLogo,
  deleteCollegeVideos,
  removeDeletedVideoMutation,
  saveCollegeVideos,
  updateCollegeVideos,
  getLimitedVideos,
  uploadCollegeImages,
  deleteCollegeImages,
  getAllColleges,
  updateViewCount
};
